import { processDetailHref } from "../processes/processDetailHref";
import React, { useContext } from "react";
import { DashboardPeopleSelectionContext } from "./DashboardPeopleSelectionContext";
import { DashboardDateSelectionContext } from "./DashboardDateSelectionContext";
import { getBrowserHash } from "../../utils/urlHash";
import { readDateSelection } from "./dateSelection";
import * as Tooltip from "@radix-ui/react-tooltip";
import { Workflow } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ProcessGraphLink({
  slug,
  name,
  userIds,
  showLabel = false,
  prominent = false,
  className = "",
  labelClassName = "",
}: {
  slug: string;
  name: string;
  userIds?: string[] | "all";
  showLabel?: boolean;
  prominent?: boolean;
  className?: string;
  labelClassName?: string;
}) {
  const { t } = useTranslation();
  const { selection: people } = useContext(DashboardPeopleSelectionContext);
  const { selection: rememberedDates } = useContext(DashboardDateSelectionContext);
  const dates = readDateSelection(getBrowserHash(), rememberedDates);
  const linkPeople = userIds ?? (people === "all" ? "all" : people.split(",").filter(Boolean));
  return (
    <Tooltip.Provider delayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <Link
            to={processDetailHref(slug, linkPeople, dates)}
            // Pages list several of these icons, so screen readers need the process name.
            aria-label={t("dashboard.open_process_graph_for", { process: name })}
            className={`inline-flex shrink-0 items-center justify-center gap-2 rounded-lg text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 ${prominent ? "bg-insight px-4 py-3 text-surface hover:bg-insight-strong focus-visible:outline-insight" : "min-h-8 min-w-8 border border-info/20 bg-info/5 px-2 text-info hover:bg-info/15 focus-visible:outline-info"} ${className}`}
          >
            <Workflow className="h-4 w-4 shrink-0" aria-hidden="true" />
            {showLabel && <span className={labelClassName}>{t("dashboard.process_graph")}</span>}
          </Link>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="top"
            sideOffset={6}
            collisionPadding={8}
            className="pointer-events-none z-[100] max-w-72 rounded-lg border border-outline bg-surface px-3 py-2 text-xs text-text shadow-lg"
          >
            {t("dashboard.open_process_graph")}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
